<template>
  <EmailBinding />
</template>

<script>
import EmailBinding from '../components/templates/EmailBinding'

export default {
  components: {
    EmailBinding
  }
}
</script>
